#@import Booking.Presenters.Base
#@export Booking.Presenters.PartySize

class Booking.Presenters.PartySize extends Booking.Presenters.Base

  toHash: ->
    partySize = @model.getPartySize()
    selected = @parentModel.getSelectedPartySize() is partySize

    {partySize, selected}

  bhc: ->
    "partysize:#{@model.getPartySize()}"
